import SideModal from "/src/components/modal/SideModal/SideModal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from '/src/components/form/Form';
import ConversationLogsModalVariablesDetails from './ConversationLogsModalVariablesDetails/ConversationLogsModalVariablesDetails';
import ConversationLogsModalPathDetails from './ConversationLogsModalPathDetails/ConversationLogsModalPathDetails';
import SliderTab from "/src/components/slider/sliderTab/SliderTab";
import "./ConversationLogsModal.css";
const ConversationLogsModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    const itemsConversations = [
        { name: 'Variables', component: <ConversationLogsModalVariablesDetails data={data} /> },
        { name: 'Path', component: <ConversationLogsModalPathDetails data={data} /> },
    ];

    return (
        <SideModal id={modal.id} autoClose="true" onClose={onClose} style={{ width: '550px', overflow : 'unset'}}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={onClose} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="conversation_logs_edit_container">
                <Form.Title>{title}</Form.Title>
                <Form.Body className="conversation_logs_body_container">
                    <SliderTab name={"slide_conversation_logs_form"} items={itemsConversations} classNameTab="conversation_logs_modal_tab_justify" classNameIndicator="space_left_conversation_logs_modal" type="tab"></SliderTab>
                </Form.Body>
            </Form>
        </SideModal>
    )
});


export default ConversationLogsModal;